
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class SabitBilgiGetAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "GttSabitBilgiGet";
        super(baseUrl);
    }


    getSabitBilgi() {

        return this.get();

    }

}
export default new SabitBilgiGetAPI();